var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLinkedinNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17832 19H9.6709V11H7.17832V19Z",
    fill: "#00AAE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4605 7C9.26586 7 9.9196 7.65017 9.9196 8.45119C9.9196 9.25249 9.26586 9.90265 8.4605 9.90265C7.65208 9.90265 7 9.25249 7 8.45119C7 7.65017 7.65208 7 8.4605 7Z",
    fill: "#00AAE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 10.8584C18.5436 10.8584 19 12.4512 19 14.5987V19H16.543V15.094C16.543 14.1695 16.5016 12.98 15.2222 12.98C13.9251 12.98 13.6588 13.9877 13.6588 15.0279V19H11.2374V11H13.6588V12.0882H13.6611C13.9934 11.4613 14.8074 10.8584 16.02 10.8584Z",
    fill: "#00AAE5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 24.6,
    height: 24.6,
    rx: 5.8,
    stroke: "#00AAE5",
    strokeWidth: 1.4
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedinNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin-nav.13b88f92.svg";
export { ForwardRef as ReactComponent };